var $4aa59f3c6a796cae$exports = {};
$4aa59f3c6a796cae$exports = {
  "dragDescriptionKeyboard": "Pritisnite Enter da biste po\u010Deli povla\u010Diti.",
  "dragDescriptionKeyboardAlt": "Pritisnite Alt + Enter za po\u010Detak povla\u010Denja.",
  "dragDescriptionLongPress": "Dugo pritisnite za po\u010Detak povla\u010Denja.",
  "dragDescriptionTouch": "Dvaput dodirnite da biste po\u010Deli povla\u010Diti.",
  "dragDescriptionVirtual": "Kliknite da biste po\u010Deli povla\u010Diti.",
  "dragItem": function dragItem(args) {
    return "Povucite stavku ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Povucite ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " odabranu stavku");
      },
      other: function other() {
        return "ovoliko odabranih stavki: ".concat(formatter.number(args.count));
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Pritisnite Enter za povla\u010Denje ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " odabrana stavka");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " odabrane stavke");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Pritisnite Alt + Enter za povla\u010Denje ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " odabrana stavka");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " odabrane stavke");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Dugo pritisnite za povla\u010Denje ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " odabrana stavka");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " odabrane stavke");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Po\u010Deli ste povla\u010Diti. Pritisnite tipku tabulatora da biste do\u0161li do cilja ispu\u0161tanja, a zatim Enter da biste ispustili stavku ili Escape da biste prekinuli povla\u010Denje.",
  "dragStartedTouch": "Po\u010Deli ste povla\u010Diti. Do\u0111ite do cilja ispu\u0161tanja, a zatim dvaput dodirnite da biste ispustili stavku.",
  "dragStartedVirtual": "Po\u010Deli ste povla\u010Diti. Do\u0111ite do cilja ispu\u0161tanja, a zatim kliknite ili pritisnite Enter da biste ispustili stavku.",
  "dropCanceled": "Povla\u010Denje je prekinuto.",
  "dropComplete": "Ispu\u0161tanje je dovr\u0161eno.",
  "dropDescriptionKeyboard": "Pritisnite Enter da biste ispustili stavku. Pritisnite Escape da biste prekinuli povla\u010Denje.",
  "dropDescriptionTouch": "Dvaput dodirnite da biste ispustili stavku.",
  "dropDescriptionVirtual": "Kliknite da biste ispustili stavku.",
  "dropIndicator": "pokazatelj ispu\u0161tanja",
  "dropOnItem": function dropOnItem(args) {
    return "Ispustite na stavku ".concat(args.itemText);
  },
  "dropOnRoot": "Ispustite na",
  "endDragKeyboard": "Povla\u010Denje. Pritisnite Enter da biste prekinuli povla\u010Denje.",
  "endDragTouch": "Povla\u010Denje. Dvaput dodirnite da biste prekinuli povla\u010Denje.",
  "endDragVirtual": "Povla\u010Denje. Kliknite da biste prekinuli povla\u010Denje.",
  "insertAfter": function insertAfter(args) {
    return "Umetnite iza stavke ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Ispustite ispred stavke ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Umetnite izme\u0111u stavki ".concat(args.beforeItemText, " i ").concat(args.afterItemText);
  }
};
export { $4aa59f3c6a796cae$exports as default };